import { useNavigate, useSearchParams, useParams, useLocation } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { getParticularProject } from "../apis/projects/projects";
import BackButton from "../assets/icons/BackButton";
import ActivitiesUnderProject from "../features/ics/projectics/ActivitiesUnderProject";
import ProjectActivityLogDemo from "../features/ics/projectics/ProjectActivityLogDemo";
import ProjectIcBanner from "../features/ics/projectics/ProjectIcBanner";
import ProjectIcDetails from "../features/ics/projectics/ProjectIcDetails";
import Heading from "../ui/Heading";
import ComponentPdfExportButton from "../components/ComponentPdfExportButton";
import PdfOnlyContent from "../features/ics/projectics/PdfOnlyContent";
import ShareButton from "../components/ShareButton";
import { ProfileContext } from "../contexts/ProfileContext";
import { getCertificateDetails } from "../apis/impact-report/report";
import { prewarmTwitterCard } from "../utils/twitterPrewarm";
import Button from "../ui/Button";
import ButtonNew from "../ui/ButtonNew";
const Logo = '/assets/images/impactfoundry.png'

function ProjectIc() {
    const navigate = useNavigate()
    const location = useLocation();
    const { state } = useContext(ProfileContext);
    const mintedIcs = state?.filter((ic) => ic.status === 'MINTED');
    const { certificateId } = useParams();
    const [projectData, setProjectData] = useState(null);
    const [searchParams] = useSearchParams();
    const liveStats = searchParams.get('liveStats') === "true";
    const projectTitle = searchParams.get('projectTitle')
    // liveStats
    // Check if URL contains "/share" to hide buttons
    const isShareUrl = location.pathname.includes('/share');

    useEffect(() => {
        const fetchProjectData = async () => {
            try {
                const data = await getCertificateDetails(certificateId);
                console.log(data, "certificate data here")
                setProjectData(data);

                // Pre-warm Twitter card cache for this certificate
                if (certificateId) {
                    console.log('Pre-warming Twitter card for certificate:', certificateId);
                    prewarmTwitterCard(certificateId).then(success => {
                        if (success) {
                            console.log('Twitter card pre-warming completed successfully');
                        } else {
                            console.log('Twitter card pre-warming failed, but continuing normally');
                        }
                    }).catch(error => {
                        console.error('Twitter card pre-warming error:', error);
                    });
                }
            } catch (error) {
                console.error('Error fetching project data:', error);
            }
        };

        if (certificateId && !liveStats) {
            fetchProjectData();
        }

        const projectTitleElement = document.getElementById('project-title');
        if (projectTitleElement) {
            projectTitleElement.scrollIntoView({
                behavior: 'smooth',

            });

        }
    }, [certificateId, liveStats]);
    const imageTimeStampForCert = mintedIcs.find((ic) => ic?._id === certificateId)?.imageGenerationTimestamp;
    console.log(projectData, certificateId, liveStats, typeof liveStats, mintedIcs, imageTimeStampForCert, "see this is the projectData newing")
    return <>
        {isShareUrl && <div className=" px-14 py-[.625rem] border-b-2 border-borderUnderline flex items-center justify-between">
            <div className="flex items-center  ">
                <img className="w-12 h-12" alt="Atlantis logo" src={Logo} />
                <div>
                    <h1 className="text-textBold text-base " type="medium">
                        Impact Foundry
                    </h1>
                    {/* <h3 type="large" className={'text-[#969696]'}>
                            Foundry
                        </h3> */}
                </div>
            </div>
            <div>
                <ButtonNew
                    type="button"
                    fixedMinWidth={true}
                    variant="blue"
                    size="sm"
                    onClick={() => window.open("https://app.impactfoundry.xyz/", "_blank")}
                >
                    Join Now
                </ButtonNew>

            </div>

        </div>}
        <div className="">
            <div className="px-5 pt-9 " >
                <div className="flex items-center justify-between" >
                    <div className="flex items-center">
                        {!isShareUrl && <BackButton id="project-title" onClick={() => navigate(-1)} />}
                        <Heading type={'pageHeading'} className={'text-textPrimary ml-3'}>
                            {projectData?.project?.title || projectTitle}
                        </Heading>
                    </div>

                    {!isShareUrl && !liveStats && (
                        <div className="flex items-center gap-3">
                            {/* Share Button with Modal */}
                            <ShareButton
                                projectTitle={projectData?.project?.title}
                                certificateImage={projectData?.imageUri}
                                shareUrl={`https://app.impactfoundry.xyz/profile/gallery/projectic/${certificateId}`}
                                shareText={`My proof of impact just went onchain, thanks to Impact Certificates, minted with Impact Foundry!\n\nCheck out my Project IC here →`}
                            />

                            {/* Component-based PDF Export Button */}
                            <ComponentPdfExportButton
                                projectTitle={projectData?.project?.title || 'Project Report'}
                                organizationName="Solarpunk Guild"
                                projectData={projectData}
                                className=""
                                customFilename={"abc_report"}
                                buttonText="Export as PDF"
                            />
                        </div>
                    )}
                </div>

            </div>

            <ProjectIcBanner certificateImage={projectData?.imageUri} />
            <div className="pt-9 px-16" >
                <ProjectIcDetails projectId={liveStats ? certificateId : projectData?.projectId} imageGenerationTimestamp={liveStats ? null : imageTimeStampForCert} />
                <ActivitiesUnderProject projectTitle={liveStats ? projectTitle : projectData?.project?.title} projectId={liveStats ? certificateId : projectData?.projectId} imageGenerationTimestamp={liveStats ? null : imageTimeStampForCert} />
                <ProjectActivityLogDemo projectId={liveStats ? certificateId : projectData?.projectId} imageGenerationTimestamp={liveStats ? null : imageTimeStampForCert} />
            </div>

            {/* Hidden PDF Preview Section - Required for export functionality */}
            <div
                id="pdf-content"
                style={{
                    position: 'absolute',
                    left: '-9999px',
                    top: '-9999px',
                    width: '210mm',
                    minHeight: '297mm',
                    visibility: 'visible',
                    backgroundColor: 'white'
                }}
            >
                <PdfOnlyContent projectData={projectData} />
            </div>

        </div>

    </>
}

export default ProjectIc;